import { sortBy } from "lodash";
import { AccountType } from "shared/types/accounts";
import { getAccountDisplayName } from "./get-accounts-name";

export function sortAccounts(accounts: AccountType[]): AccountType[] {
  return sortBy(accounts, (acc) => getAccountDisplayName(acc).toLowerCase());
}
